import axios from 'axios'
// 导入提示
import store from '../store'
import router from '@/router/index'
import utilsFun from '../assets/js/CommonUtil'

const utils = new utilsFun()
import { getRequestUrl } from '@/utils/define'
// 导入token check
import VerifyToken from '@/utils/tokenCheck'
import request from '@/utils/request'
// 表示上一次时间戳
let preTimes = null
// 停留时间
const stayTimes = 5000
let timer = null
let timerQueue = null
let queue = []

// create an axios instance
const service = axios.create({
  // 设置基础url
  baseURL: '',
  headers: { 'Content-Type': 'application/json;charset=UTF-8', 'Cache-Control': 'no-cache' },
  timeout: 20000
})

const contrastTimer = () => {

  timer = setInterval(() => {

    if ( (Date.now() - preTimes) > stayTimes ) {
      preTimes = null
      clearInterval(timer)
    }
  }, 1000)
}

// request interceptor
service.interceptors.request.use(async config => {
    // 设置请求的基础url
    config['baseURL'] = getRequestUrl()

    // 重新请求次数
    config['retry'] = 2
    // 重新请求间隔时间
    config['retryDelay'] = 500
    const token = store.getters.token
    const tokenFlag = store.getters.tokenFlag

    /* 判断表示是否需要添加loading */
    if ( config['data'] && typeof config['data']['isLoading'] === 'undefined' ) {
      config['data']['isLoading'] = true
    }

    // 5s倒计时判断为为空 && 不是hpc请求 && 需要token(0 表示不需要token 1 表示需要token) && token存在
    if ( !preTimes && config['url'].indexOf('hpc/') === - 1 && config['data']['tokenNeed'] && (tokenFlag && tokenFlag !== '') ) {

      preTimes = Date.now()
      await VerifyToken()
      contrastTimer()
    }

    // 判断是否请求图片 如果是图片要求返回blob类型
    // if ( config['url'].indexOf('VerCode/captchaImage') !== - 1
    //   || config['url'].indexOf('Resume/DownLoadAttachment') !== - 1 ) config['responseType'] = 'blob'

    if ( config['url'].indexOf('VerCode/captchaImage') !== - 1 ) config['responseType'] = 'blob'

    // 判断是否需要验证token
    if ( config['data']['tokenNeed'] && (tokenFlag && tokenFlag !== '') ) {

      // 判断token是否存在
      config.headers.token = token
    }

    // 判断是否是hpc处理
    if ( config['url'].indexOf('hpc/') === - 1 && config['data']['isLoading'] ) {

      // 判断是否已经开始加载数据
      if ( queue.length === 0 ) utils._loadding()
      // 随机数 添加到队列
      queue.push(utils._getuuId())
    }

    // 删除多余参数
    delete config['data']['tokenNeed']
    delete config['data']['isLoading']

    return config
  }, error => {

    Messsage.error('请求超时,刷新后重新请求.')
    console.log(error) // for debug
  }
)

// response interceptor
service.interceptors.response.use(
  response => {

    // 判断是否是hpc处理
    if ( response['config']['url'].indexOf('hpc/') === - 1 ) {

      // 删除对象
      queue.pop()
      // 判断是否已经开始加载数据
      if ( queue.length === 0 ) utils._removeLoadding()
    }

    // 容错处理 最多允许10s
    if ( !timerQueue ) {
      timerQueue = setTimeout(() => {
        utils._removeLoadding()
        clearTimeout(timerQueue)
        timerQueue = null
        queue = []
      }, 10000)
    }

    // 如果请求过程中 token失效 重新请求
    // 判断token是否已经失效
    const tokenFlag = store.getters.tokenFlag
    if ( response.status === 200 && response.data.code === '20007' && tokenFlag !== '' ) {
      return Promise.reject(response)

      // 判断是否绑定手机号
    } else if ( response.status === 200 && response.data.code === '20036' ) {

      router.push({ path: '/bindPhone' })
      // 判断是否完善三步走
    } else if ( response.status === 200 && ([ '20040', '20041', '20042' ].includes(response.data.code)) ) {

      // 字段【_skipSwitch】一时保留，原来分为三部走 显示是一步走了
      store.dispatch('_skipSwitch', response.data.code === '20040' ? '1' : response.data.code === '20041' ? '2' : '3')
      router.push({ path: '/perfectInfo' })
    } else {

      // 判断是否有uuid存在 如果存在表示请求的是图片验证码 反之不是
      let result = ''
      if ( response.headers['uuid'] ) {
        result = {
          'uuid': response.headers.uuid,
          'code': response.headers.code,
          'data': response.data,
          'state': response.headers.state ? response.headers.state : undefined
        }
      }

      return result === '' ? response.data : result
    }
  },
  error => {
    // 删除动画
    utils._removeLoadding()
    return Promise.reject(error)

  }
)

/**
 * @author lihh
 * @description 针对promise失败进行拦截
 */
service.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {

  // 获取配置
  let config = err.config
  // 判断是否存在重新请求次数 如果没有 直接请求失败
  if ( !config || !config.retry ) return Promise.reject(err)

  // 设置初期请求次数
  config.__retryCount = config.__retryCount || 0

  // 请求次数 大于 指定次数 直接请求失败
  if ( config.__retryCount >= config.retry ) {
    return Promise.reject(err)
  }

  //
  config.__retryCount += 1

  // Create new promise to handle exponential backoff
  var backoff = new Promise(function(resolve) {
    setTimeout(function() {
      resolve()
    }, config.retryDelay || 1)
  })

  // Return the promise in which recalls axios to retry the request
  // 清空数据源
  preTimes = null
  clearInterval(timer)
  // 设置需要token
  let paramData = JSON.parse(config['data'])
  paramData['tokenNeed'] = '1'

  return backoff.then(function() {
    return request({
      url: config['url'],
      method: 'POST',
      data: paramData
    })
  })
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js